export const state = () => ({
	cities: [],
	popularRoutes: [],

	isLoadCities: true,
	isLoadPopularRoutes: true,
});

export const mutations = {
	setCities: function (state, cities) {
		state.cities = cities;
		state.isLoadCities = false;
	},
	setPopularRoutes: function (state, popularRoutes) {
		state.popularRoutes = popularRoutes;
		state.isLoadPopularRoutes = false;
	},
};

export const actions = {
	getCities: async function ({ state, commit }) {
		if (!state.isLoadCities) {
			return
		}
		const response = await this.$api.agent.transport.get("/route/cities").then((res) => {
			return res.data
		}).catch((err) => {
			return []
		});
		commit("setCities", response);
	},
	getPopularRoutes: async function ({ state, commit }) {
		if (!state.isLoadPopularRoutes) {
			return
		}
		const response = await this.$api.agent.transport.get("/route/popular").then((res) => {
			return res.data
		}).catch((err) => {
			return []
		});
		commit("setPopularRoutes", response);

	},
}
